export const REGISTRATION_REFRESH_KEY = 'taogo-registration-refresh-pending';

export function markRegistrationRefreshPending() {
  try {
    sessionStorage.setItem(REGISTRATION_REFRESH_KEY, '1');
  } catch (_) {
    // Storage may be unavailable in an embedded browser; login still succeeds in memory.
  }
}

export function isRegistrationRefreshPending() {
  try {
    return sessionStorage.getItem(REGISTRATION_REFRESH_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function clearRegistrationRefreshPending() {
  try {
    sessionStorage.removeItem(REGISTRATION_REFRESH_KEY);
  } catch (_) {
    // Ignore storage failures.
  }
}
